"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SimpleZonePrice =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimpleZonePrice, _DomainObject_1$Domai);

  function SimpleZonePrice(zoneId, price) {
    var _this;

    _classCallCheck(this, SimpleZonePrice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleZonePrice).call(this));
    _this.zoneId = zoneId;
    _this.price = price;
    return _this;
  }

  return SimpleZonePrice;
}(DomainObject_1.DomainObject);

exports.SimpleZonePrice = SimpleZonePrice;

SimpleZonePrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimpleZonePrice.name);
  return {
    zoneId: builder.str('zoneId'),
    price: builder.bigNum('price')
  };
}();